// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3shDZ","errorLogs":"EditorFooter_errorLogs__21fDX"};